export default __webpack_public_path__ + "static/media/downloads.164bc013.png";